// @givmo/design-system — the house focus indicator, published once.
//
// ⚠ THE RING ALONE IS NOT A FOCUS INDICATOR. `shadow-ring`
// (`0 0 0 4px rgba(60,109,229,.16)`) composites over `surface` to **1.23:1** — under the 3:1 floor
// SC 1.4.11 sets for the active edge of a control. It reads as a tint, not as "you are here". The
// house pairing since givmo-web #379 is the ring PLUS a 2px solid `brand-500` outline (4.66:1 on
// white, 3.78:1 against the ring's own tint), and `IconButton` / `Button` / `ModuleSquare` have
// carried it inline ever since.
//
// It is a constant rather than a fourth copy because the copies drifted: the nav drawer's touch
// target, the cluster's avatar trigger and the stacked row action each took the ring half alone —
// three controls that are a phone admin's ONLY way into the navigation, the suite and a member's
// access, none of them showing a compliant focus state.
//
// ⚠ `outline-solid` IS LOAD-BEARING, not decoration. `outline-none` (which every one of these
// recipes sets, to drop the UA ring) sets `--tw-outline-style: none`, and Tailwind 4's width utility
// reads that variable — so `outline-2` alone emits a 2px outline of style `none`, which paints
// nothing. Re-arming the style in the same variant is what makes the outline exist.
//
// An outline also survives a clipping ancestor where an outset box-shadow does not, which is why it
// is the right half to add for controls that live inside the drawer's `overflow-y-auto` list.
export const FOCUS_RING =
  'focus-visible:shadow-ring focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500';

/**
 * The same outline, drawn INSIDE the control, for one whose container clips anything outside it. A
 * tab strip is a scrolling lane (`TAB_LANE`, CBG-DS2), and a tab panel is a full-width region in a
 * card: an outset outline or ring there loses its edges. The SaaS tab and the tab panel wear it, as
 * does the hand-rolled strip that mirrors the tabs (the Board meeting page's link-tabs). The charity
 * statement and the admin Settings strip spell the same recipe inline.
 *
 * It keeps the compliant half of the pairing, the 2px solid `brand-500` outline, and drops the
 * outset ring, which a clipping container would cut anyway. `outline-solid` is load-bearing here too.
 */
export const INSET_FOCUS_RING =
  'focus-visible:outline-solid focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand-500';
